import {
  SET_ORDER_ACTIONS,
  SET_ORDER_NUMBER,
  SET_ORDER_DETAILS,
  SET_SELECTED_ACTION,
  SET_SEARCH_COUNTRY,
  SET_PRIVILEGE_COUNTRIES,
  SET_PROCESSING_ORDER,
  SET_COLUMN_VISIBILITY,
  SET_SELECTED_SERVICE,
  SET_SELECTED_ARTICLE,
  CLEAR_ORDER_DETAILS
} from "./types";

export function setOrderActions(orderActions) {
  return {
    type: SET_ORDER_ACTIONS,
    payload: orderActions
  };
}

export function setOrderNumber(orderNumber) {
  return {
    type: SET_ORDER_NUMBER,
    payload: orderNumber
  };
}

export function setOrderDetails(orderDetails) {
  return {
    type: SET_ORDER_DETAILS,
    payload: orderDetails
  };
}

export function clearOrderDetails(){
  return {
    type: CLEAR_ORDER_DETAILS,
    payload: undefined
  }
}

export function setSelectedAction(selectedAction) {
  return {
    type: SET_SELECTED_ACTION,
    payload: selectedAction
  };
}
export function setSearchCountry(searchCountry){
  return {
    type: SET_SEARCH_COUNTRY,
    payload: searchCountry
  }
}

export function setPrivilegeCountries(privilegeCountries){
  return {
    type: SET_PRIVILEGE_COUNTRIES,
    payload: privilegeCountries
  }
}

export function setProcessingOrder(processingOrder) {
  return {
    type: SET_PROCESSING_ORDER,
    payload: processingOrder
  };
}

export function setColumnVisibility(column, value) {
  return {
    type: SET_COLUMN_VISIBILITY,
    payload: {
      column,
      value
    }
  };
}

export function setSelectedService(rowId, value) {
  return {
    type: SET_SELECTED_SERVICE,
    payload: {
      rowId,
      value
    }
  };
}

export function setSelectedArticle(rowId, value) {
  return {
    type: SET_SELECTED_ARTICLE,
    payload: {
      rowId,
      value
    }
  };
}
